export default "__VITE_ASSET__CxI$09z4__"